import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { IProcessRequest } from "../../../model/request/IProcessRequest";
import { IDanhSachMienGiamSelectByLopsRequest } from "../../../model/request/mien-giam/IDanhSachMienGiamSelectByLopsRequest";
import { IDanhSachMienGiamViewModel } from "../../../model/respone/mien-giam/IAccDanhSachMienGiamHocPhi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDanhSachMienGiamActionsObj = {
  LOAD_START: {} as IDanhSachMienGiamSelectByLopsRequest,
  LOAD_SUCCESS: {} as IDanhSachMienGiamViewModel[],
  LOAD_ERRR: "",

  CHANGE_FOCUS_TREEVIEW_VALUE: {} as ITreeviewLopFocusedValue | undefined,
  CHANGE_DISPLAY_MODE: {} as "full" | "popup",

  CHANGE_DOI_TUONG: 0,
  CHANGE_MIENGIAM_SELECTED_IDS: [] as number[],
  CHANGE_TYPE_DISPLAY: 0,

  DUYET_START: {} as IProcessRequest<number[]>,
  DUYET_SUCCESS: [] as IDanhSachMienGiamViewModel[],
  DUYET_ERROR: "",

  HUY_DUYET_START: {} as IProcessRequest<number[]>,
  HUY_DUYET_SUCCESS: [] as IDanhSachMienGiamViewModel[],
  HUY_DUYET_ERROR: "",

  CLOSE_PROCESSING_MODAL: undefined,
};
export const eDanhSachMienGiamActionIds = generateActionTypeIds(
  eDanhSachMienGiamActionsObj,
  "DANH_SACH_MIEN_GIAM"
);
export type IDanhSachMienGiamActionTypes = IGenericActionType<
  typeof eDanhSachMienGiamActionsObj,
  "DANH_SACH_MIEN_GIAM"
>;
